import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { isParameterFiltered } from '@shared/http/http-param-filter';
import { environment } from 'environments/environment';
import { omitBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { QuickSearchResult } from '../data/quick-access.model';

@Injectable({
  providedIn: 'root',
})
export class QuickAccessService {
  private readonly httpClient = inject(HttpClient);

  quickSearch(
    predicate: string,
    limit: number = 15,
    chargePointOperatorId?: string
  ): Observable<QuickSearchResult> {
    const body = omitBy(
      {
        search: predicate,
        chargePointOperatorId,
        limit,
      },
      p => isParameterFiltered(p)
    );
    return this.httpClient.post<QuickSearchResult>(`${environment.bffEopSearch}/search`, body);
  }
}
